var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnomoticsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1133.9 425.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #08191f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.9,
    y: 104.1,
    width: 1000,
    height: 217
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.5,318.1H0V106.6h37.5v211.5ZM90.5,106.6l26,108.2v-108.2h33.5v211.5h-32l-29.5-116v116h-33.5V106.6h35.5ZM202.5,106.6l26,108.2v-108.2h33.5v211.5h-32l-29.5-116v116h-33.5V106.6h35.5ZM457,216.1l17-109.5h42.5v211.5h-34.5v-135l-20,135h-14l-20.5-135v135h-33V106.6h45.5l17,109.5ZM726.5,106.6v37.5h-26v174h-37.5v-174h-26v-37.5s89.5,0,89.5,0ZM773.5,318.1h-37.5V106.6h37.5v211.5ZM886.5,150.6c0-24.2-7.6-46.5-44-46.5h-8c-33.3,0-44.5,22.4-44.5,48v119c0,26.5,8.6,50,45,50h6.5c33.3,0,45-24,45-49v-47h-38v58.5h-19v-143.5h19v46.5h38v-36ZM970.2,206.8l-21.6-24.2c-9.4-10.5-11.6-17.5-11.6-27.5v-18.5h16.5v37.5h36.5v-28.5c0-28.5-11.4-41.5-41-41.5h-7.5c-26.5,0-43,14.7-43,42v11.5c0,20.5,4.3,36.9,20.2,54l21.9,24.2c11.4,12.2,12.4,18,12.4,32.8v17h-19v-45.5h-37.5v37.2c0,28.5,14.3,43.8,43,43.8h7.5c31.6,0,46-20.6,46-52.5v-7.5c0-18.5-3.7-32.7-22.8-54.3h0ZM333,104.1h-8.5c-32.7,0-46,21.3-46,54v111.5c0,33.3,16.1,51.5,46,51.5h8.5c28.5,0,45-20.5,45-51.5v-111.5c0-32.4-11.7-54-45-54ZM338.5,283.1h-20v-142h20v142ZM587,104.1h-8.5c-32.7,0-46,21.3-46,54v111.5c0,33.3,16.1,51.5,46,51.5h8.5c28.5,0,45-20.5,45-51.5v-111.5c0-32.4-11.7-54-45-54ZM592.5,283.1h-20v-142h20v142Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnomoticsLogo);
export default __webpack_public_path__ + "static/media/innomotics-logo.5e8cfb077d861f6f0ac0017583f96cd0.svg";
export { ForwardRef as ReactComponent };